<template>
  <div class="cc-container"
    :class="{
      'is-horizontal': this.direction === 'horizontal'
    }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'cc-container',
  props: {
    /**
     * @description 子元素的排列方向 可选值 horizontal / vertical
     * @type string
     */
    direction: {
      type: String,
      default: 'vertical'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/mixins.scss';
.cc-container {
  @include flex(column);
  &.is-horizontal {
    flex-direction: row;
  }
}
</style>
